import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { CreateTeamRequest, CreateTeamResponse, TeamListItem, TeamUser } from "../types/teams.types";

import { teamsQueryKeys } from "./queryKeyFactory";

const toOptimisticTeamUsers = (userIds: CreateTeamRequest["userIds"]): TeamUser[] =>
    (userIds ?? []).map((userId) => ({
        userId,
        name: null,
        email: null,
        jobTitle: null,
        country: null,
    }));

export const useCreateTeamMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<CreateTeamResponse, Error, CreateTeamRequest>({
        mutationFn: (payload) => salesApiService.teams.createTeam(payload),
        onSuccess: (data, variables) => {
            const newTeam: TeamListItem = {
                teamId: data.teamId,
                name: variables.name,
                description: variables.description ?? null,
                membersCount: variables.userIds?.length ?? 0,
                previewMembers: null,
                users: toOptimisticTeamUsers(variables.userIds),
            };
            queryClient.setQueryData<TeamListItem[]>(teamsQueryKeys.all(), (teams) =>
                teams ? [...teams, newTeam] : [newTeam],
            );
            void queryClient.invalidateQueries({ queryKey: teamsQueryKeys.all(), exact: true });
        },
    });
};
